import { autoinject } from 'aurelia-framework';
import { SessionStorage } from '../../utils/session-storage-service';
import { CookieService } from '../../utils/cookie-service';
import { AppSettings } from '../../utils/appsettings';
import { EventAggregator } from 'aurelia-event-aggregator';
import { Session } from 'inspector';

@autoinject
export class GlobalContextService {	
	constructor(private eventAggregator: EventAggregator) {
	}

	getKey(name: string): string {
		return `horisontti-${name}-${AppSettings.email.replace('@', '-')}`;
	}

	getItem(name: string): any {
		return SessionStorage.getFromStorage<any>(this.getKey(name));
	}

	setItem(name: string, item: any) {
		SessionStorage.pushToStorage(this.getKey(name), item);
		this.eventAggregator.publish(`itemChanged-${name}`, item);
	}

	getId(name: string): string {
		return CookieService.getCookieValue(this.getKey(name));
	}

	setId(name: string, id: string) {
		CookieService.setCookie(this.getKey(name), id);
		this.eventAggregator.publish(`idChanged-${name}`, id);
	}
}
